// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__kfhxE","title":"style_title__mIASn"};